import React from 'react';
import Icon from '../../../components/AppIcon';
import { Checkbox } from '../../../components/ui/Checkbox';

const NotificationStep = ({ notifications, onToggle }) => {
  const notificationTypes = [
    {
      id: 'events',
      title: 'Etkinlik Bildirimleri',
      description: 'Yeni etkinlikler ve etkinlik güncellemeleri hakkında bildirim al',
      icon: 'Calendar',
      recommended: true
    },
    {
      id: 'messages',
      title: 'Mesaj Bildirimleri',
      description: 'Yeni mesajlar ve sohbet güncellemeleri için bildirim al',
      icon: 'MessageCircle',
      recommended: true
    },
    {
      id: 'marketplace',
      title: 'Mağaza Bildirimleri',
      description: 'Yeni ürünler, indirimler ve stok güncellemeleri',
      icon: 'ShoppingBag',
      recommended: false
    },
    {
      id: 'community',
      title: 'Topluluk Bildirimleri',
      description: 'Forum gönderileri, yorumlar ve etkileşimler',
      icon: 'Users',
      recommended: false
    },
    {
      id: 'weather',
      title: 'Hava Durumu Uyarıları',
      description: 'Seçtiğin bölgelerdeki hava durumu değişiklikleri',
      icon: 'CloudRain',
      recommended: true
    },
    {
      id: 'newsletter',
      title: 'Haber Bülteni',
      description: 'Haftalık özet ve SUP ipuçları',
      icon: 'Mail',
      recommended: false
    }
  ];

  return (
    <div className="w-full max-w-4xl mx-auto px-4 md:px-6 lg:px-8 py-6 md:py-8 lg:py-10">
      <div className="text-center mb-8 md:mb-10 lg:mb-12">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[var(--color-foreground)] mb-3 md:mb-4">
          Bildirim Tercihleri
        </h2>
        <p className="text-sm md:text-base lg:text-lg text-[var(--color-muted-foreground)] max-w-2xl mx-auto">
          Hangi konularda bildirim almak istediğinizi seçin. İstediğiniz zaman değiştirebilirsiniz
        </p>
      </div>
      <div className="space-y-4 md:space-y-5 lg:space-y-6">
        {notificationTypes?.map((notification) => (
          <div
            key={notification?.id}
            className="bg-[var(--color-card)] rounded-xl md:rounded-2xl p-5 md:p-6 lg:p-7 border border-[var(--color-border)] hover:shadow-organic-sm transition-smooth"
          >
            <div className="flex items-start gap-4 md:gap-5">
              <div className="w-12 h-12 md:w-14 md:h-14 bg-[var(--color-muted)] rounded-lg md:rounded-xl flex items-center justify-center flex-shrink-0">
                <Icon name={notification?.icon} size={24} className="text-[var(--color-primary)]" />
              </div>
              
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-2">
                  <h3 className="text-base md:text-lg font-semibold text-[var(--color-foreground)]">
                    {notification?.title}
                  </h3>
                  {notification?.recommended && (
                    <span className="px-2 py-1 bg-[var(--color-accent)] text-[var(--color-accent-foreground)] text-xs font-medium rounded-md">
                      Önerilen
                    </span>
                  )}
                </div>
                <p className="text-sm md:text-base text-[var(--color-muted-foreground)] mb-4">
                  {notification?.description}
                </p>
                
                <Checkbox
                  label="Bildirimleri aç"
                  checked={notifications?.[notification?.id]}
                  onChange={(e) => onToggle(notification?.id, e?.target?.checked)}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-8 md:mt-10 bg-[var(--color-muted)] rounded-xl md:rounded-2xl p-5 md:p-6 lg:p-7">
        <div className="flex items-start gap-4">
          <Icon name="Info" size={24} className="text-[var(--color-primary)] flex-shrink-0 mt-1" />
          <div>
            <h4 className="text-base md:text-lg font-semibold text-[var(--color-foreground)] mb-2">
              Bildirim Ayarları
            </h4>
            <p className="text-sm md:text-base text-[var(--color-muted-foreground)]">
              Bildirim tercihlerinizi istediğiniz zaman profil ayarlarından değiştirebilirsiniz. Önemli güvenlik bildirimleri her zaman gönderilecektir.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationStep;